var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenRefferalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 49,
    viewBox: "0 0 343 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_601)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 49,
    rx: 11,
    fill: "url(#paint0_linear_178_601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H30L20 49H10L20 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H60L50 49H40L50 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0H90L80 49H70L80 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 0H120L110 49H100L110 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 0H150L140 49H130L140 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 0H180L170 49H160L170 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 0H210L200 49H190L200 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 0H240L230 49H220L230 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 0H270L260 49H250L260 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 0H300L290 49H280L290 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 0H330L320 49H310L320 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 0H360L350 49H340L350 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_178_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25H173",
    stroke: "url(#paint1_linear_178_601)",
    strokeWidth: 13
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_178_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344 25L173 25",
    stroke: "url(#paint2_linear_178_601)",
    strokeWidth: 13
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_178_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.399 24.1272C167.369 30.103 164.443 42.549 160.981 44.5272",
    stroke: "url(#paint3_linear_178_601)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.254 26.6C171.284 32.5757 174.21 45.0218 177.672 47",
    stroke: "url(#paint4_linear_178_601)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.654 14.2363C162.588 10.2799 167.369 19.1817 169.017 24.1272C167.575 25.3636 163.083 28.2073 156.654 29.6909C148.617 31.5454 149.235 19.1817 156.654 14.2363Z",
    fill: "white",
    stroke: "url(#paint5_linear_178_601)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.853 13.9859C177.919 10.0296 173.138 18.9314 171.49 23.8768C172.932 25.1132 177.424 27.9569 183.853 29.4405C191.89 31.2951 191.272 18.9314 183.853 13.9859Z",
    fill: "white",
    stroke: "url(#paint6_linear_178_601)",
    strokeWidth: 6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_178_601",
    x: -7.2,
    y: 15.3,
    width: 187.4,
    height: 27.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_178_601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_178_601",
    x: 165.8,
    y: 15.3,
    width: 185.4,
    height: 27.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_178_601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_178_601",
    x: 139.256,
    y: 5.39963,
    width: 61.9953,
    height: 55.9368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_178_601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_601",
    x1: 171.5,
    y1: 0,
    x2: 171.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_601",
    x1: 169.628,
    y1: -9.5,
    x2: 179.792,
    y2: 32.1779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_178_601",
    x1: 318.5,
    y1: 4,
    x2: 162.117,
    y2: 27.0514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_178_601",
    x1: 164.476,
    y1: -679.673,
    x2: 168.207,
    y2: -679.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_178_601",
    x1: 174.176,
    y1: -677.2,
    x2: 170.445,
    y2: -677.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_178_601",
    x1: 159.413,
    y1: -560.431,
    x2: 168.546,
    y2: -560.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_178_601",
    x1: 181.094,
    y1: -560.681,
    x2: 171.961,
    y2: -560.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C5C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 49,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenRefferalLink);
export default __webpack_public_path__ + "static/media/hiddenRefferalLink.dcbab75690349be2084034c58bc52142.svg";
export { ForwardRef as ReactComponent };